import Button from '../base/button';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export const THEMES = [`primary`, `secondary`, `tertiary`];

export enum THEME_ENUM {
  primary = `primary`,
  secondary = `secondary`,
  tertiary = `tertiary`,
}

export const SIZES = [`xs`, `small`, `large`];

export default registerMPElement(
  `mp-button`,
  class extends Button {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        class: `string`,
        icon: `string`,
        size: {type: `string`, enum: SIZES, default: `small`},
        theme: {type: `string`, enum: THEMES},
        destructive: `boolean`,
        pressed: `boolean`,
      };
    }

    get config() {
      return Object.assign(super.config, {
        css,
        template,
      });
    }
  },
);
